import { useApiQuery } from '@locus-taxy/encore-ui-network';

// Common Entity search types
export interface EntitySearchResponse<T> {
  data: {
    content: Array<{
      entityData: T;
    }>;
    totalElements: number;
    page?: number;
    size?: number;
    totalPages?: number;
  };
  success: boolean;
}

export type Condition = {
  field: string;
  operator: string;
  value?: string | number | boolean | null;
  pattern?: string;
  caseSensitive?: boolean;
  lowerBound?: unknown;
  upperBound?: unknown;
};

export type ConditionGroup = {
  operator: 'AND' | 'OR';
  conditions: (Condition | ConditionGroup)[];
};

export interface EntitySearchRequest {
  request: {
    condition?: ConditionGroup;
    query?: string;
    filters?: Record<string, string>;
    sort: Array<{
      field: string;
      direction: string;
    }>;
    projection?: Record<string, boolean>;
    pagination: {
      page: number;
      size: number;
      maxSize?: number;
    };
  };
}

const ENTITY_SEARCH_ENDPOINT_KEY = 'entity.search';

export function useEntitySearch<TEntityData>(
  clientId: string,
  entityName: string,
  body: EntitySearchRequest,
  options?: { enabled?: boolean }
) {
  return useApiQuery<EntitySearchResponse<TEntityData>>({
    key: [
      ENTITY_SEARCH_ENDPOINT_KEY,
      clientId,
      entityName,
      JSON.stringify(body),
    ],
    endpointKey: ENTITY_SEARCH_ENDPOINT_KEY,
    config: {
      method: 'POST',
      body,
      staleTime: 0,
      enabled: Boolean(clientId && entityName) && (options?.enabled ?? true),
    },
    params: { clientId, entityName },
  });
}
